import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { ClaimService } from './service-agents/claim.service';
import { StubInterceptor } from './interceptors/stub.interceptor';
import { environment } from '@env/environment';
import { RelatieService } from './service-agents/relatie.service';
import { SharedDataService } from './service-agents/shareddata.service';
import { SitecoreClaimService } from './service-agents/sitecoreclaim.service';
import { VerzekeringkiezerService } from './service-agents/verzekeringkiezer.service';
import { ServerErrorsInterceptor } from './interceptors/server-errors.interceptor';
import { InsurancedataService } from './service-agents/insurancedata.service';
import { DisableCacheInterceptor } from './interceptors/disable-cache.interceptor';
import { WafInterceptor } from './interceptors/waf.interceptor';
import { CrosscuttingModule } from '@crosscutting/public_api';
import { GraphQLModule } from './graphql.module';
import { GraphQLService } from './service-agents/graphQL.service';
import { SiteSettingsService } from './service-agents/site-settings.service';
import { MijnSituatieService } from './service-agents/mijnsituatie.service';
import { SchadeherstelService } from './service-agents/schadeherstel.service';
import { WoonglasschadeherstellersService } from './service-agents/woonglasschadeherstellers.service';

const nonProductionProviders = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: StubInterceptor,
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: DisableCacheInterceptor,
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: WafInterceptor,
    multi: true
  }];

const productionProviders = [{
  provide: HTTP_INTERCEPTORS,
  useClass: DisableCacheInterceptor,
  multi: true
},
{
  provide: HTTP_INTERCEPTORS,
  useClass: ServerErrorsInterceptor,
  multi: true
},
{
  provide: HTTP_INTERCEPTORS,
  useClass: WafInterceptor,
  multi: true
}];

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    CrosscuttingModule.forRoot(),
    GraphQLModule
  ],
  declarations: []
})
export class ServicesModule {
  static forRoot(): ModuleWithProviders<ServicesModule> {
    return {
      ngModule: ServicesModule,
      providers: [
        ClaimService,
        environment.production ? productionProviders : nonProductionProviders,
        MijnSituatieService,
        RelatieService,
        SchadeherstelService,
        WoonglasschadeherstellersService,
        SharedDataService,
        SitecoreClaimService,
        VerzekeringkiezerService,
        InsurancedataService,
        GraphQLService,
        SiteSettingsService
      ],
    };
  }
}
